import React, { useContext } from 'react';
import { ProductContext } from '../context/ProductContext';
import Header from '../components/Header/Header';
import ProductImages from '../components/ProductImages/ProductImages';
import VerifyProduct from '../components/Verify/VerifyProduct';
import ProductIntro from '../components/ProductDetail/ProductIntro';
import AdditionalFields from '../components/ProductDetail/AdditionalFields';
import KeyBenefits from '../components/ProductDetail/KeyBenefits';
import DirectionUse from '../components/ProductDetail/DirectionUse';
import VideoLink from '../components/ProductDetail/VideoLink';
import SocialMedia from '../components/ProductDetail/SocailMedia';
import CareInstructions from '../components/ProductDetail/CareInstructions';
import Certificate from '../components/ProductDetail/Certificate';
import Ingredient from '../components/ProductDetail/Ingredient';
import BrandDetails from '../components/ProductDetail/BrandDetails';
import MedicineFields from '../components/ProductDetail/MedicineFields';
import LiquorFields from '../components/ProductDetail/LiquorFields';
import ApparelFields from '../components/ProductDetail/ApparelFields';
import IndustrialFields from '../components/ProductDetail/IndustrialFields';
import ProductJourney from '../components/ProductJourney/ProductJourney';

const EXCLUDED_BRAND_IDS = ["Pharma", "Pharma1", "Pharma2", "Glonuts"];

const HomePage: React.FC = () => {
  const { product } = useContext(ProductContext) || {};

  // background style logic remains unchanged...
  let backgroundStyle = {};
  if (product?.bgColor && product.bgColor !== "null") {
    backgroundStyle = { backgroundColor: product.bgColor };
  } else if (product?.bgGradient?.start && product.bgGradient.end) {
    backgroundStyle = {
      background: `linear-gradient(${
        product.bgGradient.direction || 'to right'
      }, ${product.bgGradient.start}, ${product.bgGradient.end})`,
    };
  } else if (product?.backgroundImage) {
    backgroundStyle = {
      backgroundImage: `url(${product.backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    };
  }

  const shouldShowVerify = 
    product?.brandId 
    && !EXCLUDED_BRAND_IDS.includes(product.brandId);

  return (
    <div className="flex flex-col min-h-screen" style={backgroundStyle}>
      <Header />
      <main className="flex-grow">
        {/* Only render VerifyProduct when brandId is NOT in the excluded list */}
      {/* {shouldShowVerify && <VerifyProduct />} */}
        <ProductImages />
        <ProductIntro />
        <AdditionalFields />
        <ProductJourney />
        <DirectionUse />
        <KeyBenefits />
        <VideoLink />
        <CareInstructions />
        <Certificate />
        <Ingredient />
        <MedicineFields />
        <LiquorFields />
        <ApparelFields />
        <IndustrialFields />
        <BrandDetails />
        <SocialMedia />
      </main>
    </div>
  );
};

export default HomePage;
